<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 12 14">
    <path d="M12 2v3.5c0 0.273-0.227 0.5-0.5 0.5h-3.5c-0.203 0-0.383-0.125-0.461-0.312-0.078-0.18-0.039-0.398 0.109-0.539l1.078-1.078c-0.734-0.68-1.703-1.070-2.727-1.070-2.203 0-4 1.797-4 4s1.797 4 4 4c1.242 0 2.391-0.563 3.156-1.555 0.039-0.055 0.109-0.086 0.18-0.094 0.070 0 0.141 0.023 0.195 0.070l1.070 1.078c0.094 0.086 0.094 0.234 0.016 0.336-1.141 1.375-2.828 2.164-4.617 2.164-3.305 0-6-2.695-6-6s2.695-6 6-6c1.539 0 3.031 0.617 4.133 1.656l1.016-1.008c0.141-0.148 0.359-0.187 0.547-0.109 0.18 0.078 0.305 0.258 0.305 0.461z"></path>
</svg>
    


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-refresh.html